import { Injectable } from "@angular/core";
import { UnsubscribeBaseModel } from "../../base/model/UnsubscribeBase.model";
import { AppData } from "../AppData";
import { HttpClient } from "@angular/common/http";
import { CompoApp } from "../CompoApp";
import { UrlBuilder } from "../../models/frontend_entities/UrlBuilder";
import Constants from "../../Constants";
import { take } from "rxjs/operators";
import { PagedObjectHistoryDto } from "../../models/object/PagedObjectHistoryDto";
import { Observable } from "rxjs";
import { DynamicFilterRequestDto } from "../../models/dynamic-filter/dynamic-filter-request-dto.model";
import { ObjectHistoryChangeTypeEnum } from "../../enums/object/object-history-change-type.enum";
import { ObjectTimelineModel } from "../../models/timeline/object-timeline.model";
import { LocationAndParentTimelineModel } from "../../models/timeline/location-and-parent-timeline.model";

@Injectable()
export class ObjectHistoryRequestService extends UnsubscribeBaseModel{

  private data: AppData;

  constructor(private http: HttpClient,
              private app: CompoApp) {
    super();
    this.data = app.data;
  }

  //region FETCH
  fetchResourceHistoryForObject(dto: DynamicFilterRequestDto, offset: number = 0, size: number = 50 ): Observable<PagedObjectHistoryDto> {
    const url = new UrlBuilder(Constants.URLS.history.resourceHistory)
      .param('lang', this.data.getLang())
      .param('accessMode', this.data.getAccessMode())
      .param('offset', offset)
      .param('size', size)
      .build();

    return this.http.post<PagedObjectHistoryDto>(url, dto).pipe(take(1));
  }

  fetchObjectHistoryForObject(
    objectId: string,
    offset: number = 0,
    size: number = 10,
    fromMillis?: number,
    toMillis?: number,
    types?: ObjectHistoryChangeTypeEnum[]
  ): Observable<PagedObjectHistoryDto> {
    const url = new UrlBuilder(Constants.URLS.history.byObjectId)
      .param('accessMode', this.data.getAccessMode())
      .param('objectId', objectId)
      .param('offset', offset)
      .param('size', size)
      .param('fromMillis', fromMillis)
      .param('toMillis', toMillis)
      .param('types', types?.length ? types.join(',') : null)
      .build();

    return this.http.get<PagedObjectHistoryDto>(url).pipe(take(1));
  }

  fetchChildrenTimeline(
    objectId: string,
    fromMillis?: number,
    toMillis?: number
  ): Observable<ObjectTimelineModel[]> {
    const url = new UrlBuilder(`${Constants.URLS.history.childrenTimeline}/${objectId}`)
      .param('accessMode', this.data.getAccessMode())
      .param('from', fromMillis != null ? new Date(fromMillis).toISOString() : null)
      .param('to', toMillis != null ? new Date(toMillis).toISOString() : null)
      .build();

    return this.http.get<ObjectTimelineModel[]>(url).pipe(take(1));
  }

  fetchLocationAndParentTimeline(
    objectId: string,
    fromMillis?: number,
    toMillis?: number
  ): Observable<LocationAndParentTimelineModel> {
    const url = new UrlBuilder(`${Constants.URLS.history.locationAndParentTimeline}/${objectId}`)
      .param('accessMode', this.data.getAccessMode())
      .param('from', fromMillis != null ? new Date(fromMillis).toISOString() : null)
      .param('to', toMillis != null ? new Date(toMillis).toISOString() : null)
      .build();

    return this.http.get<LocationAndParentTimelineModel>(url).pipe(take(1));
  }
  //endregion

}
